export enum PoiCutoverStrategy {
  OneBatchPerTradingDate = 'ONE_BATCH_PER_TRADING_DATE',
  FlexibleBatch = 'FLEXIBLE_BATCH',
}
